import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';

export const CardWrapper = superstyled({
  name: 'ZuiCard',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row-reverse'
    }
  })
});

export const ContentWrapper = superstyled({
  name: 'ZuiContentWrapper',
  slot: 'ContentWrapper',
  tag: CardContent,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'space-between',

    [theme.breakpoints.up('md')]: {
      width: '50%',
      height: 'auto'
    }
  })
});

export const Image = superstyled({
  name: 'ZuiSharedAsset',
  slot: 'Image',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '100%',
    aspectRatio: '12/5',
    objectFit: 'cover',

    [theme.breakpoints.up('md')]: {
      width: '50%',
      aspectRatio: '15/4',
      height: 'auto'
    }
  })
});
